/**
 * Real Stories section – Slick slider, video pause on change, testimonial sync
 * Config from section data attributes (data-* on .real-stories).
 */
(function() {
  function parseBool(val) {
    return val === 'true' || val === '1';
  }

  function initSection(sectionEl) {
    var $section = window.jQuery && sectionEl.jquery ? sectionEl : window.jQuery(sectionEl);
    var $slider = $section.find('.real-stories-slider');
    if (!$slider.length) return;

    var data = $section[0].dataset || {};
    var slidesToShowMobile = parseInt(data.perPageMobile, 10) || 1;
    var autoplaySpeed = parseInt(data.autoplayInterval, 10) || 3000;

    $slider.removeClass('is-loading');
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: parseBool(data.showArrowsDesktop),
      dots: parseBool(data.showPaginationDesktop),
      infinite: parseBool(data.rewindDesktop),
      autoplay: parseBool(data.enableAutoplay),
      autoplaySpeed: autoplaySpeed,
      centerMode: true,
      centerPadding: '28%',
      prevArrow: `
        <button id="real-stories-conditions-prev" class="slick-prev conditions-prev" type="button" aria-label="Previous">
          <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.5 0.500003C7.21573 0.500002 0.499998 7.21573 0.499997 15.5C0.499997 23.7843 7.21573 30.5 15.5 30.5C23.7843 30.5 30.5 23.7843 30.5 15.5C30.5 7.21573 23.7843 0.500003 15.5 0.500003Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18 21.75L11.75 15.5L18 9.25" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      `,
      nextArrow: `
        <button id="real-stories-conditions-next" class="slick-next conditions-next" type="button" aria-label="Next">
          <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.5 30.5C23.7843 30.5 30.5 23.7843 30.5 15.5C30.5 7.21573 23.7843 0.5 15.5 0.5C7.21573 0.5 0.5 7.21573 0.5 15.5C0.5 23.7843 7.21573 30.5 15.5 30.5Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13 9.25L19.25 15.5L13 21.75" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      `,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: slidesToShowMobile,
            arrows: parseBool(data.showArrowsMobile),
            dots: parseBool(data.showPaginationMobile),
            infinite: parseBool(data.rewindMobile),
            centerMode: true,
            centerPadding: '10%'
          }
        }
      ]
    });

    $slider.on('beforeChange', function() {
      $slider.find('video').each(function() {
        this.pause();
      });
    });

    $slider.on('afterChange', function(event, slick, currentSlide) {
      var $items = $section.find('.real-stories__testimonial-item');
      $items.removeClass('active');
      $items.eq(currentSlide).addClass('active');
    });

    (function setInitialTestimonial() {
      var currentSlide = $slider.slick('slickCurrentSlide') || 0;
      var $items = $section.find('.real-stories__testimonial-item');
      $items.removeClass('active');
      $items.eq(currentSlide).addClass('active');
    })();
  }

  function run() {
    if (typeof window.jQuery === 'undefined' || !window.jQuery.fn.slick) return;
    window.jQuery('.real-stories').each(function() {
      initSection(window.jQuery(this));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(run, 500);
    });
  } else {
    setTimeout(run, 500);
  }
})();
